<template>
  <div class="p-5 user-profile-page">

    <el-alert
      v-if="!firebaseCurrentUser.emailVerified"
      title="Error alert"
      type="error"
      description="Your e-mail address not verified!"
      show-icon>
    </el-alert>

    <!--
    <el-button @click="onLoadPaddle">LOAD</el-button>
    <el-button @click="onOpenUpdate">UPDATE</el-button>
    <el-button @click="onOpenCancel">CANCEL</el-button>
    -->

    <div class="card mt-4 p-2 d-flex flex-row">
      <input type="text" class="form-control" disabled="disabled" v-model="userReadonly.subscription">
      <!--
      <el-button type="submit" class="btn btn-secondary mr-4" @click="onChangeSubscription">Change Subscription</el-button>
      -->
    </div>

    <hr />

    <!--
      cancel_url:
      update_url:
    -->

    <el-card v-if="paddle_done_loading_script">
      <el-button v-if="!paddle_done_loading_checkout" @click="onOpenCheckout">Go to Checkout</el-button>
      <div class="checkout-container"></div>
    </el-card>

    <!--
    <el-card v-if="paddle_done_loading_script">
      <div class="d-flex">
        <a href="#!" data-product="12345"><el-button class="paddle_button" >Buy now</el-button></a>

        <a href="#!" id="buy" @click.prevent="onOpenCheckout"><el-button>Buy now</el-button></a>

        <a href="https://pay.paddle.com/checkout/562045"><el-button>Buy now</el-button></a>
      </div>
    </el-card>
    -->

    <hr />

    <el-button @click="onCallProxy">Check Subscription Status</el-button>
    <el-card v-if="paddle_subscription && paddle_subscription.plan_id">
      <pre class="mini-pre">paddle_subscription: {{paddle_subscription}}</pre>
      <el-button
        type="primary"
        class="mr-4"
        @click="onOpenCheckout($event, 'checkout-container-2', paddle_subscription.update_url)">Update Payment method</el-button>
      <el-button
        type="primary"
        @click="onOpenCheckout($event, 'checkout-container-2', paddle_subscription.cancel_url)">Cancel Subscription</el-button>
      <div class="checkout-container-2"></div>
    </el-card>

    <hr />

    <pre class="mini-pre">paddle_done_loading_script: {{paddle_done_loading_script}}</pre>
    <pre class="mini-pre">paddle_done_loading_checkout: {{paddle_done_loading_checkout}}</pre>
    <pre class="mini-pre">firebaseCurrentUser.email: {{firebaseCurrentUser.email}}</pre>
    <pre class="mini-pre">firebaseCurrentUser.displayName: {{firebaseCurrentUser.displayName}}</pre>
    <pre class="mini-pre">firebaseCurrentUser.emailVerified: {{firebaseCurrentUser.emailVerified}}</pre>

  </div>
</template>

<script>
import firebase from "@firebase/app";
// import firebase from "@/generic_api/firebase/firebase";

// TODO: Fetch current subscription and show info

// TODO: Allow user to create subscription

// TODO: Allow user to cancel subscription
// TODO: Allow user to change subscription
//   --> https://paddle.com/docs/subscription-update-cancel-pages/

// TODO: Allow user to buy multiple seats

// TODO: Allow user to assign seats to users

// TODO: Show invoices

// TODO: Handle payment failues

/* CLIENT */
function call_paddle_proxy(action = 'getSubscribeList') {

  var paddleProxy = firebase.functions().httpsCallable('paddleProxy');

  return paddleProxy({ action }).then(result => {

    console.log("==========================================")
    // console.log("result", result)
    console.log("result.data", result.data)
    console.log("==========================================")

    // Read result of the Cloud Function.
    // var isPro = result.data.isPro;
    return result.data.subscription;

  }).catch(error => {
    // Getting the Error details.
    console.log("==========================================")
    console.warn(error.code)
    console.warn(error.message)
    console.warn(error.details)
    console.log("==========================================")
  });
}

export default {
  data() {
    return {
      paddle_done_loading_script: false,
      paddle_done_loading_checkout: false,
      paddle_vendor_id:  51003,
      // paddle_product_id: 562045, // <<< production
      paddle_product_id: 565311, // <<< testing
      // paddle_product_id: 563162,
      // paddle_data_email: 'test@test.de',
      // paddle_api_key: 'd93b337163a97ef15866449222f0afbd', // REMOVE?
      paddle_subscription: {},
    };
  },
  created() {
    this.$paddle = null;
    /*
    let userSettings = this.$models.userSettings.subscribeNode( this.$models.user.defaultUserId )
    userSettings.$promise.then(() => {
      this.userSettingsClone = userSettings.clone();
    })
    */
    this.onLoadPaddle();
  },
  computed: {

    userReadonly() {
      return this.$models.userReadonly.subscribeNode( this.$models.user.defaultUserId )
    },

    paddlePassthroughPayload() {
      // Additional payload that is passed to paddle, when signing up

      return JSON.stringify({
        user_id: this.$models.user.defaultUserId,
      })

      // "{\"user_id\": 98765, \"affiliation\": \"Acme Corp\"}"
    },

    firebaseCurrentUser() {
      return firebase.auth().currentUser
    }
  },
  methods: {

    notifiyUserOnError() {
      this.$notify.error({
        title: 'Error',
        message: 'Subscription management is currently not available. Please contact our support at support@goalpilot.com'
      });
    },

    onLoadPaddleLib() {
      return new Promise((resolve, reject) => {
        const src = 'https://cdn.paddle.com/paddle/paddle.js';
        const clientScriptElement = document.createElement('script');
        clientScriptElement.src = src;
        clientScriptElement.async = false;
        clientScriptElement.type = 'text/javascript';
        clientScriptElement.onload = () => {
          resolve();
        };
        this.script = document.body.appendChild(clientScriptElement);
      });
    },

    onLoadPaddle() {
      this.onLoadPaddleLib().then(() => {

        this.paddle_done_loading_script = true;
        const Paddle = window.Paddle;

        // console.log("Paddle", Paddle)
        if ( Paddle ) {
          Paddle.Setup({ vendor: this.paddle_vendor_id });
          this.$paddle = Paddle;
        } else {
          this.notifiyUserOnError();
        }
      })
    },

    /*
    onOpenUpdate() {
      if ( !this.paddle_done_loading_script ) {
        this.notifiyUserOnError();
        return
      }

      let vm = this;
      this.$paddle.Checkout.open({
        method: 'inline',
        override: 'https://paddle.com/example/update/url'
      });
    },

    onOpenCancel() {

    },
    */

    onOpenCheckout( $event, target = 'checkout-container', url_override = null ) {
      if ( !this.paddle_done_loading_script ) {
        this.notifiyUserOnError();
        return
      }

      // See: https://paddle.com/docs/checkout-parameters/
      // Upon new subscription signup the subscription_created is fired.
      let vm = this;
      let config = {
        method: 'inline',
        product: this.paddle_product_id,
        email: this.firebaseCurrentUser.email,
        // marketingConsent: true, // (Yes, if  email is also set)
        passthrough: this.paddlePassthroughPayload,
        // success: '/thank-you/',
        // referrer
        frameTarget: target, // The className of your checkout <div>
        frameInitialHeight: 366,
        frameStyle: 'width:360px; background-color: transparent; border: none;',
        loadCallback() {
          console.log("loadCallback");
          vm.paddle_done_loading_checkout = true
        },
        successCallback: function(data) {
          vm.paddleSuccess(data)
        },
        closeCallback: function(data) {
          console.log("closeCallback", data);
          vm.paddleClose(data)
        },
        debug: false,
      };
      if ( url_override ) {
        config.override = url_override;
      }
      this.$paddle.Checkout.open(config);
    },

    // mixin?
    paddleSuccess(data) {
      // This callback is executed, when a customer successfully makes a payment
      console.log("paddleSuccess", data);

      /*
      let data = {
        "checkout": {
        "created_at": "2019-07-16 01:12:30",
        "completed": true,
        "id": "36174723-chreca4be22ea84-ad4411f719",
        "coupon": {
          "coupon_code": null
        },
        "passthrough": null,
        "prices": {
          "customer": {
            "currency": "EUR",
            "unit": "0.00",
            "unit_tax": "0.00",
            "total": "0.00",
            "total_tax": "0.00"
          },
          "vendor": {
            "currency": "USD",
            "unit": "0.00",
            "unit_tax": "0.00",
            "total": "0.00",
            "total_tax": "0.00"
          }
        },
        "redirect_url": null,
        "test_variant": "newCheckout",
        "recurring_prices": {
          "customer": {
            "currency": "EUR",
            "unit": "0.00",
            "unit_tax": "0.00",
            "total": "0.00",
            "total_tax": "0.00"
          },
          "interval": {
            "length": 1,
            "type": "month"
          },
          "vendor": {
            "currency": "USD",
            "unit": "0.00",
            "unit_tax": "0.00",
            "total": "0.00",
            "total_tax": "0.00"
          }
        }
      },
      "product": {
        "quantity": 1,
        "id": 565311,
        "name": "Goalpilot DEV Free Plan"
      },
      "user": {
        "id": "56789",
        "email": "test@test.de",
        "country": "US"
      }
    }"
    */

    /*
    {
      "checkout": {
        "created_at": "2019-07-17 12:20:27",
        "completed": true,
        "id": "36254619-chre13c436467cb-929c388488", <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<
        "coupon": {
          "coupon_code": null
        },
        "passthrough": "{\"user_id\":\"GX4vxXk0cuNdBg0BdbcziqOayAw2\"}",
        "prices": {
          "customer": {
            "currency": "EUR",
            "unit": "0.00",
            "unit_tax": "0.00",
            "total": "0.00",
            "total_tax": "0.00"
          },
          "vendor": {
            "currency": "USD",
            "unit": "0.00",
            "unit_tax": "0.00",
            "total": "0.00",
            "total_tax": "0.00"
          }
        },
        "redirect_url": null,
        "test_variant": "newCheckout",
        "recurring_prices": {
          "customer": {
            "currency": "EUR",
            "unit": "0.00",
            "unit_tax": "0.00",
            "total": "0.00",
            "total_tax": "0.00"
          },
          "interval": {
            "length": 1,
            "type": "month"
          },
          "vendor": {
            "currency": "USD",
            "unit": "0.00",
            "unit_tax": "0.00",
            "total": "0.00",
            "total_tax": "0.00"
          }
        }
      },
      "product": {
        "quantity": 1,
        "id": 565311,     <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<
        "name": "Goalpilot DEV Free Plan"
      },
      "user": {
        "id": "10699543", <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<
        "email": "weustenfeld@googlemail.com",
        "country": "US"
      }
    }
    */
    },

    paddleClose(data) {

    },

    onChangeSubscription() {
      this.$router.push('/upgrade')
    },

    onCallProxy() {
      call_paddle_proxy().then((subscription) => {

        this.paddle_subscription = subscription;

        this.$notify({ message: 'DONE' })
      })
    }
  },
};
</script>

<style>
</style>
